<template>
  <div class="no-auth-page">
    <div>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#iconblank_no_access"></use>
      </svg>
    </div>
    <span class="no-auth-tips">{{ $t('components.noAuthTips') }}</span>
    <div class="router-info">
      <RowItem :title="$t('components.noAuthModule')" width="120px">
        {{ to.module }}
      </RowItem>
      <RowItem :title="$t('components.noAuthUrl')" width="120px">
        {{ to.url }}
      </RowItem>
      <RowItem :title="$t('components.noAuthFromModule')" width="120px">
        {{ from.module }}
      </RowItem>
      <RowItem :title="$t('components.noAuthFromUrl')" width="120px">
        {{ from.url }}
      </RowItem>
    </div>
    <div style="margin-top: 16px;">
      <el-button @click="$router.back()" size="small">{{ $t('components.noAuthBack') }}</el-button>
      <el-button type="primary" @click="backLogin" size="small">{{
        $t('components.noAuthBackLogin')
      }}</el-button>
    </div>
  </div>
</template>

<script>
import RowItem from '@/components/InfoCard/RowItem'
export default {
  data() {
    return {
      to: {},
      from: {}
    }
  },
  components: {
    RowItem
  },
  mounted() {
    const query = this.$route.query
    const origin = window.location.origin + '/#'
    this.to = {
      url: origin + query.toUrl,
      module: query.toModule
    }
    this.from = {
      url: origin + query.fromUrl,
      module: query.fromModule
    }
  },
  methods: {
    backLogin() {
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>
<style lang="less" scpoed>
.no-auth-page {
  height: 100vh;
  min-height: 500px;
  margin: 0 auto;
  padding-top: 100px;
  width: 90%;
  .icon {
    width: 300px;
    height: 300px;
    fill: #eee;
  }
  .no-auth-tips {
    color: #999;
    font-size: 16px;
  }
  .router-info {
    margin: 16px 0;
  }
}
</style>
